var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-percent",staticStyle:{"transition":"all 0.5s ease-out"},style:(`width: ${_vm.percent}%; background-color: ${_vm.progressColor}`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }